import { useCreateObjectDataRecordMutation } from '@redux/api'

export const useCreateObjectDataRecordWithFixedKey = (globalId: string) => {
  return useCreateObjectDataRecordMutation({
    fixedCacheKey: `create-object-data-record-${globalId}`,
  })
}
